import axios from "axios";

const BASE = "case-statuses";

export const getAllCaseStatuses = async () => {
  const response = await axios.get(BASE);
  return response.data;
};
